import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyADYF6zlpsYJjW24A65ZIf_umMnG3RqJfE',
  authDomain: 'lyrically-noted.firebaseapp.com',
  databaseURL: 'https://lyrically-noted.firebaseio.com',
  projectId: 'lyrically-noted',
  storageBucket: '',
  messagingSenderId: '331246594300',
};
firebase.initializeApp(config);

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js